import { Grid, IconButton, Tooltip } from '@mui/material';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ElementType, FC, useMemo } from 'react';

type ActionBase = {
  tooltip: string;
  color?: 'success' | 'error' | 'primary';
  disabled?: (data: any) => boolean;
  onAction?: (data: any) => void;
  onlyFirstRow?: boolean;
};

type ActionItem =
  | (ActionBase & { kind: 'function'; Icon: (data: any) => JSX.Element })
  | (ActionBase & { kind?: 'component'; Icon: ElementType });

interface ActionsRendererProps {
  actions: ActionItem[];
  disabled?: boolean;
}

const ActionsRenderer: FC<CustomCellRendererProps & ActionsRendererProps> = ({
  node,
  data,
  actions,
  disabled,
}) => {
  const actionsViews = useMemo(() => {
    return actions.map((action, i) => {
      const {
        Icon,
        color,
        tooltip,
        disabled: disabledFn,
        onAction,
        onlyFirstRow,
        kind,
      } = action;

      let disableAction = disabled || disabledFn?.(data);
      if (onlyFirstRow && node.rowIndex !== 0) {
        disableAction = true;
      }

      const iconElement = kind === 'function' ? Icon(data) : <Icon />;

      return (
        <Grid key={i}>
          <Tooltip title={tooltip}>
            <IconButton
              size="small"
              onClick={() => onAction?.(data)}
              color={color}
              disabled={disableAction}
            >
              {iconElement}
            </IconButton>
          </Tooltip>
        </Grid>
      );
    });
  }, [actions, data, disabled, node.rowIndex]);

  return (
    <Grid container direction="row" spacing={1} wrap="nowrap">
      {actionsViews}
    </Grid>
  );
};

export default ActionsRenderer;
